import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../slices/authSlice';

// Cierre de sesión automático por inactividad (1 ago 2026, pedido de
// Augusto, "por precaución"): si un cliente deja la sesión abierta y no
// interactúa con la app por 15 minutos, se cierra sola — evita que una
// sesión olvidada abierta (ej. en una laptop compartida o de uso público)
// quede accesible indefinidamente. Se reinicia el contador con cualquier
// señal real de actividad (mouse, teclado, click, scroll, touch).
//
// `logout` (authSlice.js) ya limpia localStorage y hace un
// `window.location.href = '/login'` — no hace falta duplicar esa lógica
// acá, solo dispararlo cuando se cumple el límite.
const IDLE_LIMIT_MS = 15 * 60 * 1000;
const ACTIVITY_EVENTS = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart', 'click'];

export default function useIdleLogout() {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const timerRef = useRef(null);

  useEffect(() => {
    // Sin sesión activa no hay nada que cerrar por inactividad.
    if (!token) {
      if (timerRef.current) clearTimeout(timerRef.current);
      return undefined;
    }

    const resetTimer = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        dispatch(logout());
      }, IDLE_LIMIT_MS);
    };

    resetTimer();
    ACTIVITY_EVENTS.forEach((evt) => window.addEventListener(evt, resetTimer, { passive: true }));

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      ACTIVITY_EVENTS.forEach((evt) => window.removeEventListener(evt, resetTimer));
    };
  }, [token, dispatch]);
}
